import { HttpAgent, RunAgentParameters } from '@ag-ui/client';
import { AuthHelper } from '../../../../libs/auth/AuthHelper';
import { BackendServiceUrl } from '../../../../libs/services/BaseService';

const ENDPOINT = '/api/chatagent';

export const toBackendUrl = (path: string) => new URL(path, BackendServiceUrl).toString();

/** 채팅방(sessionId)별 HttpAgent  */
const agentBySession = new Map<string, HttpAgent>();

/** 도구 결과 재호출 시 재사용할 마지막 run 파라미터 (sessionId별) */
const lastRunParamsBySession = new Map<string, RunAgentParameters>();

/** 캐시된 agent 반환, 없으면 생성 */
export async function getOrCreateAgent(sessionId: string): Promise<HttpAgent> {
  const cached = agentBySession.get(sessionId);
  if (cached) {
    await refreshAuthHeader(cached);
    return cached;
  }

  const headers: Record<string, string> = {};
  const token = await AuthHelper.getToken().catch(() => null);
  if (token) headers.Authorization = `Bearer ${token}`;

  const agent = new HttpAgent({ url: toBackendUrl(ENDPOINT), headers, threadId: sessionId });
  agentBySession.set(sessionId, agent);
  return agent;
}

async function refreshAuthHeader(agent: HttpAgent): Promise<void> {
  const token = await AuthHelper.getToken().catch(() => null);
  if (token) agent.headers.Authorization = `Bearer ${token}`;
}

/** 도구 결과 재호출에 쓸 run 파라미터 저장 */
export function setLastRunParams(sessionId: string, params: RunAgentParameters): void {
  lastRunParamsBySession.set(sessionId, params);
}

/** 저장된 run 파라미터 반환 */
export function getLastRunParams(sessionId: string): RunAgentParameters | undefined {
  return lastRunParamsBySession.get(sessionId);
}

/** 채팅방 종료 시 호출  */
export function disposeAgent(sessionId: string): void {
  const agent = agentBySession.get(sessionId);
  lastRunParamsBySession.delete(sessionId);
  if (!agent) return;
  agent.abortRun();
  agentBySession.delete(sessionId);
}

/** stop 버튼 — 진행 중 run만 중단  */
export function abortAgent(sessionId: string): void {
  agentBySession.get(sessionId)?.abortRun();
}
